import React from 'react';
import { Link } from 'react-router-dom';
import { formatShortDate } from '../utils/dateFormatter';
import { formatCount } from '../utils/numberFormatter';
import { getGuestSourceLabel, getGuestTier } from '../utils/guestDisplay';
import useLanguage from '../hooks/useLanguage';
import './GuestCard.css';

/**
 * One guest on a phone (owner view of /guests, tasks/owner-screens-mobile.md step 2).
 * The whole card links to the guest's page. Read-only: editing stays on the table view.
 */
const GuestCard = ({ guest }) => {
  const { t, language } = useLanguage();
  const totalBookings = guest.totalBookings ?? 0;
  const tier = getGuestTier(totalBookings);

  return (
    <Link to={`/guests/${guest._id}`} className="guest-card touch-card">
      <div className="guest-card-head">
        <div className="guest-card-avatar">{guest.name?.charAt(0).toUpperCase() || 'G'}</div>
        <div className="guest-card-name">{guest.name || t('guestsList.unnamed')}</div>
        <span className={`tier-badge-sm ${tier.color}`}>
          <i className={`bi ${tier.icon}`}></i> {tier.label}
        </span>
      </div>

      {(guest.phone || guest.email) && (
        <div className="guest-card-contact">
          {guest.phone && <span dir="ltr">{guest.phone}</span>}
          {guest.email && <span dir="ltr" className="guest-card-email">{guest.email}</span>}
        </div>
      )}

      <div className="guest-card-meta">
        <span>{formatCount(totalBookings, language)} {t('guestsList.bookings')}</span>
        {guest.lastBookingDate && (
          <span>{t('guestsList.lastBooking')}: {formatShortDate(guest.lastBookingDate)}</span>
        )}
        {guest.acquisitionSource && (
          <span className="source-badge-sm">{getGuestSourceLabel(guest.acquisitionSource)}</span>
        )}
      </div>
    </Link>
  );
};

export default GuestCard;
